

























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class AirwaySection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    jalan_napas: "tanpa_alat",
    opa_ukuran: "",
    ett_ukuran: "",
    ett_kedalaman: "",
    sputum: "tidak_produktif",
    sputum_warna: "",
    sputum_konsistensi: "",
    alergi_obat: "",
    alergi_makanan: "",
    alergi_debu: false,
    alergi_lainnya: ""
  };

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
  }
}
